import { render, staticRenderFns } from "./customPeriod.vue?vue&type=template&id=a1f08978&scoped=true"
import script from "./customPeriod.vue?vue&type=script&lang=js"
export * from "./customPeriod.vue?vue&type=script&lang=js"
import style0 from "./customPeriod.vue?vue&type=style&index=0&id=a1f08978&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1f08978",
  null
  
)

export default component.exports